import { Box, Grid } from '@mui/material';
import { useAdmin } from '../../contexts/admin.context';
import IncomeChart from './IncomeChart';
import InitialMessage from './InitialMessage';
import Shifts from './Shifts';

const Dashboard = () => {
  const { cafe } = useAdmin();

  return (
    <Box sx={{ maxWidth: 1000, m: '0 auto', pb: 2 }}>
      {!cafe?.messages?.initial && <InitialMessage />}

      <Grid container spacing={3}>
        <Grid item xs={12} sm={8}>
          <IncomeChart />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Shifts />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
